import { render, staticRenderFns } from "./NewTasksCard.vue?vue&type=template&id=4a378e29&scoped=true"
import script from "./NewTasksCard.vue?vue&type=script&lang=js"
export * from "./NewTasksCard.vue?vue&type=script&lang=js"
import style0 from "./NewTasksCard.vue?vue&type=style&index=0&id=4a378e29&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a378e29",
  null
  
)

export default component.exports